<template>
  <div
    class="collect-item"
    v-report="{spm:'1003.2449.3001.8299', dest:dateObject.resourceUrl,index}"
    v-view="{spm:'1003.2449.3001.7928', dest:dateObject.souresourceUrlrceUrl,index}"
  >
    <!-- 左侧文件缩略展示 -->
    <div class="file">
      <img src="@/assets/imgs/fileborder.png" alt />
      <div class="range">
        <img class="block" :src="dateObject.thumbnail" alt />
      </div>
      <img class="file-icon" :src="dateObject.fileIconUrl" alt />
    </div>
    <!-- 右侧描述信息 -->
    <div class="description">
      <a :href="dateObject.resourceUrl" target="_blank" v-query="'1003.2449.3001.8299.'+index">
        <h1 class="module-title module-click">{{dateObject.title}}</h1>
      </a>
      <p class="module-des rowspan">{{dateObject.description}}</p>
      <!-- 标签列表 -->
      <div class="tag-list">
        <ul class="module-tag">
          <a :href="item.tagUrl" v-for="item in dateObject.tagList" :key="item.id" target="_blank">
            <li>{{item.tagName}}</li>
          </a>
        </ul>
      </div>
      <div class="other">
        <div class="leftx">
          <span class="module-text margin-right-12">上传时间{{dateObject.operate_time | setTime}}</span>
        </div>
        <el-popconfirm title="确认取消收藏吗？" @confirm="unfavorite(dateObject.id)">
          <div slot="reference" class="rightx">
            <img src="@/assets/imgs/collect.png" alt />
            <span>已收藏</span>
          </div>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/utils/api";

export default {
  props: {
    dateObject: {
      type: Object,
      default: () => {
        return {
          id: "",
          fileIconUrl: "",
          resourceUrl: "",
          title: "",
          description: "",
          tagList: "",
          operate_time: "",
        };
      },
    },
    index: {
      type: Number,
    },
  },
  methods: {
    unfavorite(id) {
      get("/api/source/mp/favorite/v1/unfavorite?sourceId=" + id).then(
        (response) => {
          this.$emit("change");
        }
      );
    },
  },
  filters: {
    setTime(time) {
      let temp = new Date(time * 1000);

      let year = temp.getFullYear();
      let month =
        temp.getMonth() < 10 ? "0" + temp.getMonth() : temp.getMonth();
      let day = temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate();

      return year + "-" + month + "-" + day;
    },
  },
};
</script>

<style  lang="less">
.el-popconfirm__action {
  margin-top: 10px;

  .el-button--text {
    color: #fc5531;
  }

  .el-button--primary {
    background-color: #fc5531;
    border-color: #fc5531;
  }
}
</style>

<style lang="less" scoped>
.collect-item {
  margin-bottom: 16px;
  width: 100%;
  height: 134px;
  display: flex;
  justify-content: space-between;

  .file {
    position: relative;
    width: 100px;
    height: 134px;

    img {
      position: absolute;
      z-index: 0;
      width: 100px;
      height: 134px;
      object-fit: cover;
    }

    .range {
      position: absolute;
      z-index: 1;
      margin: 14px 8px 7px 8px;
      width: 82px;
      height: 111px;
      background: #ffffff;
      border-radius: 1px;
      border: 1px solid #f7f7fc;

      .block {
        margin: 14px 0;
        width: 82px;
        height: 83px;
        object-fit: cover;
      }
    }

    .file-icon {
      position: absolute;
      right: 4px;
      bottom: 5px;
      z-index: 2;
      width: 24px;
      height: 24px;
      object-fit: cover;
    }
  }

  .description {
    padding: 12px 0;
    width: calc(~"100% - 112px");

    .tag-list {
      margin-bottom: 8px;
      display: flex;
      align-items: center;

      .tag-ok {
        padding: 2px 8px;
        width: 55px;
        font-size: 14px;
        font-weight: 400;
        color: #999aaa;
        line-height: 20px;
        text-align: center;
        background: #f5f6f7;
        border-radius: 2px;
      }

      .line {
        margin: 0 12px;
        width: 1px;
        height: 16px;
        background: #f0f0f2;
      }

      ul {
        margin-bottom: 0;
        display: flex;
        align-items: center;
      }
    }

    .other {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .leftx {
        display: flex;
        align-items: center;
      }

      .rightx {
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          margin-right: 4px;
          display: block;
          width: 16px;
          height: 16px;
          object-fit: cover;
        }

        span {
          font-size: 12px;
          font-weight: 400;
          color: #fc5531;
          line-height: 24px;
          user-select: none;
        }
      }
    }
  }
}
</style>